import { Component, inject, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { PlatformSource, UsersService } from '@smartcharge/shared/index';
import { ToastService } from '../../../../shared/services/toast/toast.service';

@Component({
  selector: 'sc-reset-password-prompt',
  imports: [MatButtonModule, MatDialogModule, TranslateModule],
  templateUrl: './reset-password-prompt.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reset-password-prompt.component.scss'
})
export class ResetPasswordPromptComponent {
  userId = input.required<number>();

  readonly resetting = signal(false);

  private readonly dialogRef = inject(MatDialogRef<ResetPasswordPromptComponent>);
  private readonly toastService = inject(ToastService);
  private readonly userService = inject(UsersService);

  resetPassword(source: PlatformSource) {
    this.resetting.set(true);

    this.userService.resetPasswordForUser(this.userId(), source).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.toastService.error(err);
        this.resetting.set(false);
      }
    });
  }
}
